import { useInfiniteHits, useInstantSearch } from 'react-instantsearch';
import { Button } from '@/components/Button';
import { SearchProductTile } from '@/components/SearchProductTile';
import { SearchToolbar } from '@/components/SearchToolbar';
import { NoResults } from '@/components/NoResults';
import { SearchBanner } from '@/components/SearchBanner';
import { ButtonVariant } from '@/constants';
import { useSearchData } from '@/contexts/searchContext';
import { mapAlgoliaHitToProduct } from '@/utils/mapAlgoliaHitToProduct';
import { setQueryId } from '@/utils/searchAnalytics';
import * as Styled from './ResultsPanel.styled';

interface ResultsPanelProps {
  onFilterToggle: () => void;
}

export const ResultsPanel = ({ onFilterToggle }: ResultsPanelProps) => {
  const { defaultPromotionBadge } = useSearchData();
  const { results, status } = useInstantSearch();
  const { items, isLastPage, showMore, banner } = useInfiniteHits();

  if (status === 'idle' && results?.queryID) {
    setQueryId(results.queryID);
  }

  return (
    <Styled.Wrapper>
      <SearchToolbar onFilterToggle={onFilterToggle} />

      <SearchBanner banner={banner} />

      {items.length > 0 ? (
        <>
          <Styled.HitsGrid>
            {items.map((hit, index) => (
              <SearchProductTile
                key={hit.objectID}
                index={index}
                product={mapAlgoliaHitToProduct(hit, defaultPromotionBadge)}
              />
            ))}
          </Styled.HitsGrid>
          {!isLastPage ? (
            <Styled.ShowMoreWrapper>
              <Button
                handler={showMore}
                variant={ButtonVariant.Secondary}
              >
                Show More
              </Button>
            </Styled.ShowMoreWrapper>
          ) : null}
        </>
      ) : null}

      <NoResults />
    </Styled.Wrapper>
  );
};
